import { UserService } from '../services/user.service';

/**
 * Initializer to load user data from localStorage on app startup
 * This ensures user data is available immediately, even before API calls complete
 */
export function initializeUser(userService: UserService) {
    return () => {
        // Load user from localStorage if available
        userService.loadFromStorage();
        console.log('User initialized from storage:', userService.getCurrentUser());
    };
}
